<template>
    <div class="introductionBox">
        <businessBanner tabIndex="3"></businessBanner>
        <!-- 标题与简介 -->
        <div :class="isMobile?'mobileShow':'mainShow'">
            <p class="font20 fontw">投资咨询</p>
            <p class="mt36 jies">瑞和安惠深耕投资咨询领域二十余年，始终恪守"独立、公正、科学"原则，聚焦区域经济社会发展、政府治理、重大经济决策及投资管理全链条。坚持以专业化人才团队铸就卓越服务品质，拥有注册咨询师60余人，10余名国家级智库专家；服务内容涵盖规划咨询、项目咨询、评估咨询、专项咨询，年产项目数量逾千项，其中不乏国家及省市重点项目；依托全面的技术团队专业结构，服务范围涉及国民经济各主要行业，构建了完善的投资决策综合咨询服务能力，持续为国家及区域经济高质量发展赋能。</p>
            <p class="mt20 jies">瑞和安惠深入践行"云咨智策·决策引擎"战略，着力搭建数智化投资咨询业务平台，整合工程咨询数据资源仓库，开发AI业务辅助工具，致力于推动投资咨询业务从经验驱动向数据驱动、智能驱动升级，将其打造成为集团的决策大脑与智库引擎。</p>
        </div>
        <!-- 资质资信 -->
        <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main flex-row'">
                <div :class="isMobile?'contM':'flex-text'">
                    <div :class="isMobile?'contTM':'section-title'">资质资信</div>
                    <ul class="qualify-list">
                        <li><span class="li-label">甲级综合资信：</span>所有专业规划咨询和评估咨询</li>
                        <li><span class="li-label">甲级专业资信：</span>建筑；电子、信息工程(含通信、广电、信息化)；石化、化工、医药；机械(含智能制造)；轻工、纺织；市政公用工程</li>
                        <li><span class="li-label">甲级专项资信：</span>政府和社会资本合作(PPP)咨询</li>
                        <li><span class="li-label">乙级专业资信：</span>生态建设和环境工程；农业、林业；水利水电；电力(含火电、水电、核电、新能源)；建材；其他(节能)</li>
                    </ul>
                </div>
                <img :class="isMobile?'contImgShow':'flex-img'" src="@/assets/businessScope/jiaj.png" alt="">
            </div>
        </div>
        <!-- 服务范围 -->
        <div :class="isMobile?'mobileMWrap':'mainWrap'">
            <div :class="isMobile?'mainM':'main'">
                <div :class="isMobile?'contTM':'section-title'">服务范围</div>
                <!-- 咨询产品标题 -->
                <div class="svc-top">
                    <div class="svc-top-text">
                        <p class="svc-top-label">咨询产品 — 投资决策综合性咨询</p>
                        <p class="svc-top-desc">涵盖规划咨询、项目咨询、评估咨询、专项咨询四大板块，为投资决策提供全链条智力支撑</p>
                    </div>
                </div>
                <!-- 大图 -->
                <img class="svc-banner" src="@/assets/businessScope/touzi-service.png" alt="">
                <!-- 四栏详情 -->
                <div class="svc-cols">
                    <div class="svc-col">
                        <p class="svc-col-title">规划咨询</p>
                        <ul class="svc-col-list">
                            <li>国民经济和社会发展规划</li>
                            <li>专项规划</li>
                            <li>课题研究</li>
                            <li>实施方案</li>
                        </ul>
                    </div>
                    <div class="svc-col">
                        <p class="svc-col-title">项目咨询</p>
                        <ul class="svc-col-list">
                            <li>项目投资机会研究</li>
                            <li>投融资策划</li>
                            <li>项目建议书（预可行性研究）</li>
                            <li>项目可行性研究报告</li>
                            <li>项目申请报告</li>
                            <li>资金申请报告</li>
                            <li>特许经营实施方案</li>
                            <li>专项债咨询（一案两书）</li>
                        </ul>
                    </div>
                    <div class="svc-col">
                        <p class="svc-col-title">评估咨询</p>
                        <ul class="svc-col-list">
                            <li>一般评估（含规划、项目建议书、可行性研究报告、项目申请报告、资金申请报告、特许经营实施方案、初步设计等评估）</li>
                            <li>规划和项目中期评价</li>
                            <li>项目后评价</li>
                            <li>项目概预决算审查</li>
                        </ul>
                    </div>
                    <div class="svc-col">
                        <p class="svc-col-title">专项咨询</p>
                        <ul class="svc-col-list">
                            <li>社会稳定性风险评估</li>
                            <li>节能评估</li>
                            <li>绿色评价</li>
                            <li>碳排放评价</li>
                            <li>水土保持评价</li>
                            <li>绩效评价</li>
                            <li>验收报告</li>
                        </ul>
                    </div>
                </div>
                <!-- 数智化产品 -->
                <div class="digital-bar">
                    <span class="digital-label">数智化产品</span>
                    <span class="digital-tags">
                        <em>SaaS产品(4)</em>
                        <em>数据产品(5)</em>
                        <em>模型产品(8)</em>
                        <em>数字孪生产品(1)</em>
                    </span>
                </div>
            </div>
        </div>
        <!-- 荣誉奖项 -->
        <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main flex-row'">
                <div :class="isMobile?'contM':'flex-text'">
                    <div :class="isMobile?'contTM':'section-title'">荣誉奖项</div>
                    <ul class="honor-list">
                        <li>中国工程咨询协会特邀常务理事单位</li>
                        <li>河北省工程咨询协会常务理事</li>
                        <li>全球世行项目行长奖</li>
                        <li>全国优秀工程咨询成果三等奖</li>
                        <li>河北省优秀工程咨询成果一等奖</li>
                        <li>湖北省工程咨询成果一等奖</li>
                    </ul>
                </div>
                <img :class="isMobile?'contImgShow':'flex-img'" src="@/assets/businessScope/demo1.png" alt="">
            </div>
        </div>
        <!-- 典型业绩展示 -->
        <TypicalAchievement business-type="投资咨询" :show-tabs="false" />
    </div>
</template>

<script>
import businessBanner from '@/components/businessBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'
export default {
    name: 'EarlierConsultation',
    components: { businessBanner, TypicalAchievement },
    data() {
        return {}
    },
    mounted() {}
}
</script>

<style scoped>
.introductionBox {
    padding-bottom: 50px;
}
.mainShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 42px;
}
.mainWrap {
    width: 100%;
    margin-top: 42px;
}
.mobileMWrap {
    width: 100%;
    margin-top: 20px;
}
.mobileShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 20px;
}
.main {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0 60px;
}
.mainM {
    width: 100%;
    margin: 0 auto;
    padding: 10px;
}
.jies {
    line-height: 32px;
    text-indent: 2em;
    color: #444;
    font-size: 15px;
}
.contM {
    width: 100%;
    color: #666;
    line-height: 30px;
}
.contTM {
    color: #247CD6;
    font-size: 22px;
    margin-top: 20px;
    margin-bottom: 16px;
    font-weight: bold;
}
.contImgShow {
    max-width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
    border-radius: 6px;
}
/* 通用图文横排 */
.flex-row {
    display: flex;
    align-items: flex-start;
    gap: 45px;
}
.flex-text {
    flex: 1;
    min-width: 0;
}
.flex-img {
    width: 490px;
    flex-shrink: 0;
    border-radius: 6px;
    margin-top: 20px;
}
/* 板块标题 */
.section-title {
    color: #247CD6;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 28px;
    padding-left: 14px;
    border-left: 4px solid #247CD6;
    line-height: 1;
}
/* 资质资信列表 */
.qualify-list {
    list-style: none;
    padding: 0;
    margin: 0;
}
.qualify-list li {
    line-height: 36px;
    padding-left: 18px;
    position: relative;
    font-size: 15px;
    color: #555;
    margin-bottom: 8px;
}
.qualify-list li::before {
    content: "";
    width: 5px;
    height: 5px;
    background-color: #247CD6;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 16px;
}
.li-label {
    font-weight: bold;
    color: #333;
}
/* 服务范围 */
.svc-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
}
.svc-top-label {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0 0 6px;
}
.svc-top-desc {
    font-size: 14px;
    color: #888;
    margin: 0;
}
.svc-banner {
    width: 100%;
    border-radius: 8px;
    margin-bottom: 28px;
}
.svc-cols {
    display: flex;
    gap: 0;
    margin-bottom: 28px;
    background: #fff;
    border: 1px solid #e8eef6;
    border-radius: 8px;
    overflow: hidden;
}
.svc-col {
    flex: 1;
    min-width: 0;
    padding: 24px 22px;
    border-right: 1px solid #e8eef6;
}
.svc-col:last-child {
    border-right: none;
}
.svc-col-title {
    font-size: 16px;
    font-weight: bold;
    color: #247CD6;
    margin: 0 0 14px;
    padding-bottom: 10px;
    border-bottom: 2px solid #247CD6;
}
.svc-col-list {
    list-style: none;
    padding: 0;
    margin: 0;
}
.svc-col-list li {
    line-height: 30px;
    padding-left: 16px;
    position: relative;
    font-size: 13px;
    color: #555;
}
.svc-col-list li::before {
    content: "";
    width: 4px;
    height: 4px;
    background-color: #247CD6;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 13px;
}
.digital-bar {
    display: flex;
    align-items: center;
    gap: 20px;
    background: #f0f6ff;
    border-radius: 8px;
    padding: 16px 24px;
}
.digital-label {
    font-weight: bold;
    font-size: 15px;
    color: #247CD6;
    flex-shrink: 0;
}
.digital-tags em {
    font-style: normal;
    display: inline-block;
    background: #fff;
    color: #555;
    font-size: 14px;
    padding: 6px 16px;
    border-radius: 4px;
    margin-right: 12px;
    border: 1px solid #dce6f5;
}
/* 荣誉列表 */
.honor-list {
    list-style: none;
    padding-left: 0;
    margin: 0;
}
.honor-list li {
    line-height: 36px;
    padding-left: 18px;
    position: relative;
    font-size: 15px;
    color: #555;
}
.honor-list li::before {
    content: "";
    width: 5px;
    height: 5px;
    background-color: #247CD6;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 16px;
}
</style>
